import axios from "axios";

class ContractorService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  /**
   * @author Edgar Escobedo
   * @description get type contractor person
   * @date 30-11-2022
   * @param {String} token
   * @returns {Object}
   * @memberof ContractService
   */
  async getContractorsPerson(token) {
    let response = await axios.get(`${this.apiUrl}/contractorPersonType`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  }

  /**
   * @author Edgar Escobedo
   * @description get type contractor person
   * @updatedBy Brayan Salas 15-08-2023
   * @date 30-11-2022
   * @param {String} id
   * @param {String} token
   * @returns {Object}
   * @memberof ContractService
   */
  async getContarctorByEmailAndClientId(id, token, classifier) {
    let url = `${this.apiUrl}/contractor?id=${id}`
    if (classifier) url = url + `&classifier=${classifier}`

    let response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.data;
  }

  /**
   * @author Edgar Escobedo
   * @description update contractor info
   * @date 30-11-2022
   * @param {String} id
   * @param {String} contractorTypeId
   * @param {String} nombre
   * @param {String} rfc
   * @param {String} curp
   * @param {String} limitDate
   * @param {String} notes
   * @param {String} contractorStreet
   * @param {String} contractorTownship
   * @param {String} contractorZipCode
   * @param {String} contractorCountry
   * @param {String} token
   * @returns {Object}
   * @memberof ContractService
   */
  async updateContractor(
    id,
    contractorTypeId,
    nombre,
    rfc,
    curp,
    limitDate,
    notes,
    contractorStreet,
    contractorTownship,
    contractorState,
    contractorZipCode,
    contractorCountry,
    solicitudeId,
    token,
    active,
    desactivationReason
  ) {
    let response = await axios.put(
      `${this.apiUrl}/contractor`,
      {
        id,
        contractorTypeId,
        nombre,
        rfc,
        curp,
        limitDate,
        notes,
        contractorStreet,
        contractorTownship,
        contractorState,
        contractorZipCode,
        contractorCountry,
        solicitudeId,
        active,
        desactivationReason
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  }

  /**
   * @author Edgar Escobedo
   * @description get client documents for contractor
   * @date 30-11-2022
   * @param {String} token
   * @returns {Object}
   * @memberof ContractService
   */
  async getContractorClientDocuments(
    idContractor,
    token
  ) {
    let response = await axios.get(
      `${this.apiUrl}/contractorClientDocument?id=${idContractor}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  }

  /**
   * @author Edgar Escobedo
   * @description update contractorClientDocument
   * @date 30-11-2022
   * @param {String} token
   * @returns {Object}
   * @memberof ContractService
   */
  async updateContractorClientDocument(userDocument, token) {
    let response = await axios.put(
      `${this.apiUrl}/user-client-document-file`,
      userDocument,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  }

  /**
  * @author Edgar Escobedo
  * @description finish contractor request
  * @date 16-02-2023
  * @param {String} workflowContractorId
  * @param {String} idContractor
  * @param {String} token
  * @returns {Object}
  * @memberof ContractService
  */
  async finishContractorRequest(workflowContractorId, idContractor, token) {
    let response = await axios.post(`${this.apiUrl}/finish-contractor-request`,
      {
        workflowContractorId,
        idContractor
      }, {

      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Edgar Escobedo
  * @description Second validation contractor
  * @date 21-02-2023
  * @param {String} workflowContractorId
  * @param {String} token
  * @returns {Object}
  * @memberof ContractService
  */
  async secondValidationContractor(workflowContractorId, idContractor, token) {
    let response = await axios.post(`${this.apiUrl}/second-verification-contractor`,
      {
        workflowContractorId,
        idContractor
      }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Edgar Escobedo
  * @description GET contractors by userId
  * @date 20-04-2023
  * @param {String} userId
  * @param {String} token
  * @returns {Object}
  * @memberof ContractService
  */
  async getContractorsByUserId(userId, token) {
    let response = await axios.get(`${this.apiUrl}/contractor-by-userId`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description GET all contractors or supliers
  * @date 20-04-2023
  * @param {String} cClassifierKey
  * @param {String} clientId
  * @param {String} companyId
  * @param {String} token
  * @returns {Object}
  * @memberof ContractService
  */
  async getContarctorsOrSupliersByClientIdAndKey(clientId, classifierKey, token) {
    let response = await axios.get(`${this.apiUrl}/contractors?clientId=${clientId}&cClassifierKey=${classifierKey}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    return response
  }


  /**
  * @author Edgar Escobedo
  * @description Delete userClientDocument
  * @date 13-06-2023
  * @param {String} id
  * @param {String} token
  * @returns {Object}
  * @memberof ContractService
  */
  async deleteUserClientDocumentIdById(id, token) {
    let response = await axios.delete(`${this.apiUrl}/userClientDocument?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    return response.data
  }

  /**
  * @author Edgar Escobedo
  * @description Update logo contractor
  * @date 11-07-2023
  * @param {String} id
  * @param {data} logo
  * @param {String} token
  * @returns {Object}
  * @memberof ContractService
  */
  async updateLogoContractor(logo, token) {
    let response = await axios.post(
      `${this.apiUrl}/contractor-logo`,
      logo,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  /**
  * @author Edgar Escobedo
  * @description insert or delete companyContractor
  * @date 12-07-2023
  * @param {String} companyId
  * @param {String} contractorId
  * @param {Number} action
  * @param {String} token
  * @returns {Object}
  * @memberof ContractService
  */
  async insertDeleteCompanyContractor(contractorId, companyId, action, token) {
    let response = await axios.post(`${this.apiUrl}/company-contractor-actions`,
      {
        contractorId,
        companyId,
        action
      }, {

      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
* @author Edgar Escobedo
* @description insert or delete contractorClassifier
* @date 13-07-2023
* @param {String} classifierId
* @param {String} contractorId
* @param {Number} action
* @param {String} token
* @returns {Object}
* @memberof ContractService
*/
  async insertDeleteContractorClassifier(contractorId, classifierId, action, token) {
    let response = await axios.post(`${this.apiUrl}/contractor-classfiers-actions`,
      {
        contractorId,
        classifierId,
        action
      }, {

      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  }


  /**
  * @author Edgar Escobedo
  * @description get type persons by key
  * @date 17-07-2023
  * @param {String} keyGroup
  * @param {String} token
  * @returns {Object}
  * @memberof ContractService
  */
  async getPersonTypeByKey(keyGroup, token) {
    let response = await axios.get(`${this.apiUrl}/status-application-type?keyGroup=${keyGroup}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    return response.data
  }

  /**
  * @author Pedro Antonio
  * @description get type persons by additionalKeyGroup
  * @date 17-07-2023
  * @param {String} additionalKeyGroup
  * @param {String} token
  * @returns {Object}
  * @memberof ContractService
  */
  async getPersonTypeByAdditionalKeyGroup(additionalKeyGroup, token) {
    let response = await axios.get(`${this.apiUrl}/status-application-additional?additionalKeyGroup=${additionalKeyGroup}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    return response.data
  }

  /**
   * @author Pedro Antonio Ramos Martínez
   * @description Verify if invited user is invited REPSE
   * @param {String} token
   * @param {Number} userId
   * @returns {Array}
   */
  async verifyInvitedisREPSE(userEmail, token) {
    let response = await axios.get(
      `${this.apiUrl}/invited-is-repse?userEmail=${userEmail}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }
}

export { ContractorService as default };
